export const MONTH_OPTIONS = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
];

export const YES_NO_OPTIONS = [
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' },
];

export interface RevShareConfigDto {
  identifier: string;
  connectorName: string;
  login: number;
  periodType: string;
  hwmPeriod: string;
  revSharePercentage: number;
  highWaterMark: number;
  includeCommissions: boolean;
  includeSwaps: boolean;
  activeLprsPnlConfiguration: boolean;
  id: number;
  dataSourceId: number;
  hwmMonth: number | null;
  hwmYear: number;
  quarter: number | null;
  isApiBased: boolean;
  isTerminal: boolean;
}

export interface RevShareConfigFilterInput {
  platformId?: number | null;
  login?: number | null;
  swapsIncluded?: boolean | null;
  commissionsIncluded?: boolean | null;
  skipCount?: number;
  maxResultCount?: number;
  sorting?: string;
  draw?: number;
}

export interface SaveRevShareConfigInput {
  platformId: number;
  login: number;
  revSharePercentage: number;
  highWaterMark: number;
  periodType: number;
  quarter: number | null;
  hwmMonth: number | null;
  hwmYear: number;
  includeCommissions: boolean;
  includeSwaps: boolean;
  activeLprsPnlConfiguration: boolean | null;
}

export interface UpdateRevShareConfigInput extends SaveRevShareConfigInput {
  id: number;
}

export interface ConnectorOptionDto {
  id: number;
  name: string;
  isTerminal: boolean;
  accountLogin: number | null;
}

export interface RevShareProfileOptionDto {
  id: number;
  text: string;
  periodType: string;
  highWaterMark: number;
  revSharePercentage: number;
}

export interface RevShareReportInput {
  id: number;
  year: number;
  month: number | null;
  quarter: number | null;
}

export interface RevShareResultRowDto {
  hwmPeriod: string;
  hwmPeriodSort: number;
  pnl: number | null;
  swaps: number | null;
  commissions: number | null;
  netPnL: number | null;
  hwm: number | null;
  rsPnL: number | null;
  revShare: number | null;
  equity: number | null;
  newEquity: number | null;
  credit: number | null;
}

export interface RevShareReportResultDto {
  items: RevShareResultRowDto[];
  message: string | null;
}
